import { createSlice } from "@reduxjs/toolkit";
import { updateIntake } from "services/intake/intake";

const initialState = {
    intake : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const updateBlogSlice = createSlice({
    name: 'updateIntake',
    initialState,
    extraReducers: {
        [updateIntake.pending]: (state) => {
            state.intake.isLoading = true;
        },
        [updateIntake.fulfilled]: (state, { payload }) => {
            state.intake.isLoading = false;
            state.intake.isSuccess = true;
            state.intake.data = payload;
        },
        [updateIntake.rejected]: (state, { payload }) => {
            state.intake.isLoading = false;
            state.intake.isSuccess = false;
            state.intake.errorMessage = payload
        }
    }
})
export default updateBlogSlice.reducer;